import React from 'react';
import { useTranslation } from 'react-i18next';

interface TimeOffConfirmationModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  timeOffDate: Date;
  timeOffTypeName?: string;
  isWeekend?: boolean
}

const TimeOffConfirmationModal: React.FC<TimeOffConfirmationModalProps> = ({
  show,
  onClose,
  onConfirm,
  timeOffDate,
  timeOffTypeName,
   isWeekend = false
}) => {
  const { t } = useTranslation();

  const formatDate = (date: Date): string => {
    return new Date(date).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  return (
    <div
      className="modal fade show d-block"
      tabIndex={-1}
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 999999 }}
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          
          <div className="modal-body text-center py-4">
            <div className="mb-4">
              <i className="ki-duotone ki-information fs-5x text-warning">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
              </i>
            </div>

            <h5 className="mb-4">{t('Schedule on a non-working day?')}</h5>

            {/* <p className="text-muted mb-2">
              {t('The selected date')} <strong>{formatDate(timeOffDate)}</strong>
              {timeOffTypeName && ` ${t('has')} ${timeOffTypeName}`} {t('and is marked as time-off.')}
            </p> */}

            <p className="text-muted">{t('Do you want to continue?')}</p>
          </div>

          <div className="modal-footer justify-content-center border-0 pt-0 pb-8">
            <button
              type="button"
              className="btn btn-secondary me-3"
              onClick={onClose}
            >
              {t('Cancel')}
            </button>

            <button
              type="button"
              className="btn btn-primary"
              onClick={onConfirm}
            >
              {t('Schedule')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeOffConfirmationModal;